import classNames from 'classnames';
import React from 'react';
import Button from '../../components/Button';
import styles from './PostActionButton.module.scss';

interface PostActionButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

const PostActionButton = ({
  children,
  disabled,
  onClick,
}: PostActionButtonProps) => {
  const childProp =
    typeof children === 'string'
      ? {
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML: { __html: children },
        }
      : { children };

  return (
    <Button onClick={onClick} disabled={disabled}>
      <div
        className={classNames('post-action-button', styles.button, {
          disabled,
        })}
        {...childProp}
      />
    </Button>
  );
};

export default PostActionButton;
